import { useEffect } from 'react'

const INPUT_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

/** A single keyboard shortcut binding. */
export interface KeyboardShortcut {
  key: string
  handler: (e: KeyboardEvent) => void
  /** Fire even when focus is inside an input/textarea/select or contentEditable. */
  alwaysFire?: boolean
}

export default function useKeyboardShortcuts(shortcuts: KeyboardShortcut[]): void {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      const active = document.activeElement as HTMLElement | null
      const inInput = INPUT_TAGS.has(active?.tagName ?? '') ||
                      !!active?.isContentEditable
      shortcuts.forEach(({ key, handler, alwaysFire }) => {
        if (e.key === key && (!inInput || alwaysFire)) {
          handler(e)
        }
      })
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [shortcuts])
}
